<template>
  <div>
    <el-table :data="userList" height="calc(100vh - 300px)">
      <el-table-column prop="userId" label="用户ID">
        <template slot-scope="scope">
          <span>{{ scope.row.userId }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="coinWallet" label="地址" />
      <el-table-column prop="coinType" label="币种" />
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>

    <!-- 编辑用户信息dialog -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'

export default {
  name: 'UserList',
  data() {
    return {
      updateForm: {},
    }
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('userAddress', [
      'updateUserType',
      'updateDividendStatus',
      'updateMark',
      'allowTrade',
      'allowTransfer',
      'allowSwitchBin',
    ]),
    ...mapMutations('userAddress', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    handleUpdate(selected) {
      this.updateForm = selected
      this.setUserinfoDetail(selected)
      this.setUserinfoDetailDialogVisible(true)
    },
  },
  computed: {
    // ...mapGetters('userAddress', ['userList']),
    ...mapState('userAddress', [
      'userList',
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
    ]),
  },
}
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: skyblue;
  font-weight: bold;
}
</style>
